import { TherapyItem } from "../components/therapy/BiWazeTherapyCard";

function getCurrentWeekDates(): { iso: string; label: string }[] {
  const today = new Date();
  const dayOfWeek = today.getDay(); // 0 = Sunday
  const monday = new Date(today);
  monday.setDate(today.getDate() - ((dayOfWeek + 6) % 7)); // move to Monday

  return Array.from({ length: 7 }, (_, i) => {
    const d = new Date(monday);
    d.setDate(monday.getDate() + i);
    return {
      iso: d.toISOString().split("T")[0], // YYYY-MM-DD
      label: d.toLocaleDateString("en-US", { month: "short", day: "2-digit" }),
    };
  });
}
function generateDailyValues(target: number) {
  const weekDates = getCurrentWeekDates();
  return weekDates.map((date) => {
    const value = Math.floor(Math.random() * (target + 1)); // random value up to target
    const percent = Math.round((value / target) * 100);
    return {
      date,
      value,
      target,
      percent,
      isWeekly: false,
    };
  });
}

export const AverageMock = [
  {
    title: "Vest treatments",
    goal: "4/day",
    id: 1,
    aggregationType: "daily",
    dailyValues: generateDailyValues(4),
  },
  {
    title: "Breathing routines",
    goal: "4/day",
    id: 2,
    aggregationType: "daily",
    dailyValues: generateDailyValues(4),
  },
  {
    title: "Sleep",
    goal: "8/day",
    id: 3,
    aggregationType: "daily",
    dailyValues: generateDailyValues(8),
  },
  {
    title: "Steps",
    goal: "5k/day",
    id: 4,
    aggregationType: "daily",
    dailyValues: generateDailyValues(5200),
  },
];

export const DateRangeMock = (() => {
  const today = new Date();
  const dayOfWeek = today.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday

  // Assuming week starts on Monday
  const monday = new Date(today);
  monday.setDate(today.getDate() - ((dayOfWeek + 6) % 7));

  const sunday = new Date(monday);
  sunday.setDate(monday.getDate() + 6);

  const formatDate = (date: Date) => date.toISOString().split("T")[0];

  return {
    startDate: formatDate(monday),
    endDate: formatDate(sunday),
    dayCount: 7,
  };
})();

const weekDates = getCurrentWeekDates();

const getRandomInt = (min: number, max: number) =>
  Math.floor(Math.random() * (max - min + 1)) + min;

export const otherTherapiesHealthMockData = [
  {
    name: "Vest treatments",
    value: 0,
    unit: "of 4",
    subText: "today",
    target: 4,
    isSpecial: true,
    color: "#68C998",
    dailyValues: weekDates.map(() => getRandomInt(0, 4)),
    detailedDailyValues: weekDates.map((date) => ({
      date,
      value: getRandomInt(0, 4),
      isWeekly: false,
      values: [],
    })),
  },
  {
    name: "Breathing routines",
    value: 0,
    unit: "of 4",
    subText: "today",
    target: 4,
    isSpecial: true,
    color: "#68C998",
    dailyValues: weekDates.map(() => getRandomInt(0, 4)),
    detailedDailyValues: weekDates.map((date) => ({
      date,
      value: getRandomInt(0, 4),
      isWeekly: false,
      values: [],
    })),
  },
  {
    name: "Sleep",
    value: 0,
    unit: "of 8",
    subText: "Hours",
    target: 8,
    color: "#68C998",
    dailyValues: weekDates.map(() => getRandomInt(0, 8)),
    detailedDailyValues: weekDates.map((date) => ({
      date,
      value: getRandomInt(0, 8),
      isWeekly: false,
      values: [],
    })),
  },
  {
    name: "Steps",
    value: 0,
    unit: "",
    subText: "of 5,200",
    target: 5200,
    color: "#68C998",
    dailyValues: weekDates.map(() => getRandomInt(0, 5200)),
    detailedDailyValues: weekDates.map((date) => ({
      date,
      value: getRandomInt(0, 5200),
      isWeekly: false,
      values: [],
    })),
  },
  // {
  //   name: "Wellbeing",
  //   value: "Good",
  //   unit: "",
  //   subText: "",
  //   target: 5,
  //   color: "#0778CF",
  //   visualType: "emoji",
  //   dailyValues: weekDates.map(() => getRandomInt(1, 5)),
  //   detailedDailyValues: weekDates.map((date) => ({
  //     date,
  //     value: getRandomInt(1, 5),
  //     label: "Good",
  //     isWeekly: false,
  //     values: [],
  //   })),
  // },
  // {
  //   name: "Heart Rate",
  //   value: 0,
  //   unit: "bpm",
  //   subText: "Average",
  //   target: 3,
  //   color: "#0778CF",
  //   visualType: "arrow",
  //   dailyValues: weekDates.map(() => getRandomInt(60, 100)),
  //   dailyLabels: weekDates.map(() => getRandomInt(60, 100)),
  //   detailedDailyValues: weekDates.map((date) => ({
  //     date,
  //     value: getRandomInt(60, 100),
  //     isWeekly: false,
  //     values: [],
  //   })),
  // },
  // {
  //   name: "Air Quality",
  //   value: 0,
  //   unit: "",
  //   subText: "Low health risk",
  //   target: 3,
  //   color: "#0778CF",
  //   visualType: "arrow",
  //   dailyValues: weekDates.map(() => getRandomInt(0, 3)),
  //   dailyLabels: weekDates.map(() => getRandomInt(0, 3)),
  //   detailedDailyValues: weekDates.map((date) => ({
  //     date,
  //     value: getRandomInt(0, 3),
  //     isWeekly: false,
  //     values: [],
  //   })),
  // },
];

export const therapyMockData: TherapyItem[] = [
  {
    name: "Clear Therapy",
    type: "clear",
    value: "12",
    unit: "mins",
    days: weekDates.map((dateObj, i) => ({
      date: dateObj.iso, // 👈 Extract just the ISO string from the date object
      active: i % 2 === 0,
      ...(i === 0 ? { error: "Skipped session" } : {}),
    })), // 👈 Remove .toString() - days should be an array, not a string
  },
  {
    name: "Cough Therapy",
    type: "cough",
    value: "5",
    unit: "uses",
    days: weekDates.map((dateObj, i) => ({
      date: dateObj.iso, // 👈 Extract just the ISO string from the date object
      active: i % 3 === 0,
      ...(i === 1 ? { error: "High pressure detected" } : {}),
    })),
  },
];

export const treatmentSessionChartMockData = (() => {
  const weekDates = getCurrentWeekDates();

  return {
    dates: weekDates.map((d) => d.label),
    today: "Today",
    aggregationType: "daily",
    clearData: weekDates.map(() => Math.floor(Math.random() * 20)),
    coughData: weekDates.map(() => Math.floor(Math.random() * 10)),
    vestData: weekDates.map(() => Math.floor(Math.random() * 30)),
    todayInfo: {
      minutes: Math.floor(Math.random() * 20),
      sessions: Math.floor(Math.random() * 3),
    },
    coughRecords: weekDates.map((d) => ({
      date: d.iso,
      active: Math.random() > 0.5,
      error: Math.random() > 0.7,
      notification: null,
      sessions: Math.floor(Math.random() * 4),
      value: Math.floor(Math.random() * 15),
      sessionValues: Array.from({ length: Math.floor(Math.random() * 3) }, () =>
        Math.floor(Math.random() * 15)
      ),
    })),
    detailedData: weekDates.map((d) => ({
      date: d.iso,
      dayName: d.label,
      aggregationType: "daily",
      isWeekly: false,
      isMonthly: false,
      therapy: {
        cough: {
          sessions: Math.floor(Math.random() * 3),
          minutes: Math.floor(Math.random() * 30),
          sessionValues: Array.from(
            { length: Math.floor(Math.random() * 3) },
            () => Math.floor(Math.random() * 15)
          ),
        },
        clear: {
          sessions: Math.floor(Math.random() * 3),
          minutes: Math.floor(Math.random() * 30),
          sessionValues: Array.from(
            { length: Math.floor(Math.random() * 3) },
            () => Math.floor(Math.random() * 15)
          ),
        },
        vest: {
          sessions: Math.floor(Math.random() * 3),
          minutes: Math.floor(Math.random() * 30),
          sessionValues: Array.from(
            { length: Math.floor(Math.random() * 3) },
            () => Math.floor(Math.random() * 15)
          ),
        },
      },
    })),
  };
})();

export const detailedMockData = treatmentSessionChartMockData.detailedData;

export const getDailyData = () => {
  const randomValue = (max: number) => Math.floor(Math.random() * (max + 1));

  const today = new Date().toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
  return {
    goals: [
      {
        title: "Goals",
        data: [
          {
            title: "Vest",
            adherence_type: "vest_treatment",
            value: randomValue(4),
            target: 4,
            label: "treatments",
            showAddButton: true,
            hasGoal: true,
            hasData: true,
          },
          {
            title: "Breathing",
            adherence_type: "breathing_treatment",
            value: randomValue(4),
            target: 4,
            label: "routines",
            showAddButton: true,
            hasGoal: true,
            hasData: true,
          },
          {
            title: "Sleeping",
            adherence_type: "sleep_tracking",
            value: randomValue(8),
            target: 8,
            label: "hours",
            showAddButton: false,
            hasGoal: true,
            hasData: true,
          },
          {
            title: "Steps",
            adherence_type: "step_tracking",
            value: randomValue(5200).toString(),
            label: "of 5,200",
            hasGoal: true,
            hasData: true,
          },
        ],
      },
      {
        title: "My Health",
        data: [
          {
            title: "WellBeing",
            adherence_type: "wellbeing",
            wellness: ["Good", "Neutral", "Bad"][randomValue(2)],
            label: "Neutral",
            hasData: true,
          },
          {
            title: "Heart Rate",
            adherence_type: "heart_rate",
            value: randomValue(120),
            units: "bpm",
            label: "routines",
            hasData: true,
          },
        ],
      },
    ],
    therapies: [
      {
        name: "BiWaze® Cough",
        adherence_type: "biwaze_cough",
        value: randomValue(5),
        unit: "uses",
        progress: randomValue(100),
        therapiesPerDay: 2,
        className: "biwaze-cough",
        hasData: true,
        hasPairedDevice: true,
        hasGoal: true,
        completed: [
          { value: 5, date: today },
          { value: 10, date: today },
          { value: 15, date: today },
        ],
      },
      {
        name: "BiWaze® Clear",
        adherence_type: "biwaze_clear",
        value: randomValue(60),
        unit: "min",
        progress: randomValue(100),
        therapiesPerDay: 4,
        className: "biwaze-clear",
        hasData: true,
        hasPairedDevice: true,
        hasGoal: true,
        completed: [
          { value: 20, date: today },
          { value: 25, date: today },
          { value: 30, date: today },
        ],
      },
    ],
    date: new Date().toLocaleDateString("en-US", {
      weekday: "long",
      month: "long",
      day: "numeric",
    }),
    devices: [],
  };
};
// Mock data generator

interface VitalEntry {
  date: string;
  values: number[];
}
export const insightsMockData = () => {
  const therapies = [];
  // Explicitly type vitals
  const vitals: {
    heart_rate: VitalEntry[];
    spo2: VitalEntry[];
    aqi: VitalEntry[];
  } = {
    heart_rate: [],
    spo2: [],
    aqi: [],
  };

  // Random helper
  const rand = (min: any, max: any) =>
    Math.floor(Math.random() * (max - min + 1)) + min;

  // Find Monday of the current week
  const today = new Date();
  const dayOfWeek = today.getDay(); // Sunday=0, Monday=1 ...
  const monday = new Date(today);
  monday.setDate(today.getDate() - ((dayOfWeek + 6) % 7)); // Go back to Monday
  const startDate = monday.toISOString().split("T")[0];

  // Loop through Monday → Sunday
  for (let i = 0; i < 7; i++) {
    const date = new Date(monday);
    date.setDate(monday.getDate() + i);
    const dateStr = date.toISOString().split("T")[0];

    // Therapies with random values
    therapies.push({
      date: dateStr,
      breathing_treatment: rand(0, 5),
      vest_treatment: rand(0, 5),
      biwaze_cough: rand(0, 15),
      biwaze_clear: rand(0, 5),
    });

    // Vitals with random arrays
    vitals.heart_rate.push({
      date: dateStr,
      values: Array.from({ length: rand(1, 5) }, () => rand(60, 120)),
    });

    vitals.spo2.push({
      date: dateStr,
      values: Array.from({ length: rand(1, 5) }, () => rand(90, 100)),
    });
    vitals.aqi.push({
      date: dateStr,
      values: Array.from({ length: rand(1, 5) }, () => rand(0, 5)),
    });
  }

  return {
    therapies,
    vitals,
    isYearlyData: false,
    startDate,
  };
};
export const generateMockDashboardData = () => {
  const weekDates = getCurrentWeekDates();
  const dates = weekDates.map((d) => d.iso);
  const startDate = dates[0];
  const endDate = dates[dates.length - 1];

  const rnd = (min: number, max: number) =>
    Math.floor(Math.random() * (max - min + 1)) + min;

  type VitalEntry = {
    date: string;
    values: number[];
  };

  // Generate vitals for each day with random lengths and values
  const generateVitals = (min: number, max: number): VitalEntry[] =>
    dates.map((date) => ({
      date,
      values: Array.from({ length: rnd(1, 5) }, () => rnd(min, max)),
    }));

  // Insights logic (Format B) - builds stats and random trends
  const calculateInsights = (vitals: {
    spo2: VitalEntry[];
    heart_rate: VitalEntry[];
    aqi: VitalEntry[];
  }) => {
    // therapies per day randomised
    const therapyVals = dates.map((d) => ({
      date: d,
      breathing_treatment: rnd(0, 4),
      vest_treatment: rnd(0, 4),
      biwaze_cough: rnd(0, 15),
      biwaze_clear: rnd(0, 5),
    }));

    const buildValues = (sourceArray: VitalEntry[], min: number, max: number) =>
      dates.map((d, i) => {
        const src = sourceArray?.[i];
        const generated =
          src && Array.isArray(src.values) && src.values.length
            ? src.values
            : Array.from({ length: rnd(1, 5) }, () => rnd(min, max));
        return { date: d, values: generated };
      });

    const aqiVals = buildValues(vitals.aqi || [], 0, 3);
    const hrVals = buildValues(vitals.heart_rate || [], 60, 120);
    const spo2Vals = buildValues(vitals.spo2 || [], 90, 100);

    const computeStats = (entries: VitalEntry[]) => {
      const flat = entries.flatMap((e) => e.values);
      if (!flat.length) return { min: null, max: null, avg: null, count: 0 };
      const min = Math.min(...flat);
      const max = Math.max(...flat);
      const avg = Math.round(flat.reduce((s, v) => s + v, 0) / flat.length);
      return { min, max, avg, count: flat.length };
    };

    return {
      availableVitals: [
        "spo2",
        "heart_rate",
        "aqi",
        "blood_pressure",
        "respiratory_rate",
      ],
      requestedVitals: ["spo2", "heart_rate", "aqi"],
      therapies: therapyVals,
      vitals: {
        aqi: aqiVals,
        heart_rate: hrVals,
        spo2: spo2Vals,
      },
      randomValues: {
        spo2: computeStats(spo2Vals),
        heart_rate: computeStats(hrVals),
        aqi: computeStats(aqiVals),
        healthScore: rnd(30, 100),
        trend: {
          spo2: [-1, 0, 1][rnd(0, 2)],
          heart_rate: [-1, 0, 1][rnd(0, 2)],
          aqi: [-1, 0, 1][rnd(0, 2)],
        },
      },
    };
  };

  // Build vitals object (randomized)
  const vitals = {
    spo2: generateVitals(90, 100),
    heart_rate: generateVitals(60, 120),
    aqi: generateVitals(0, 3),
  };

  // Therapy history (daily) - randomized
  const therapies = dates.map((date) => ({
    date,
    breathing_treatment: rnd(0, 4),
    vest_treatment: rnd(0, 4),
    biwaze_cough: rnd(0, 15),
    biwaze_clear: rnd(0, 5),
  }));

  // TherapyData cards - randomized flags and summary values
  const therapyData = [
    {
      name: "BiWaze® Cough",
      unit: "uses",
      type: "cough",
      value: rnd(0, 15),
      hadConnectedDevice: Math.random() > 0.5,
      hasPairedDevice: Math.random() > 0.5,
      days: dates.map((date) => ({
        date,
        active: Math.random() > 0.5,
        completionPercentage: rnd(0, 100),
        value: rnd(0, 5),
        sessions: rnd(0, 3),
        error: Math.random() > 0.85,
        notification: Math.random() > 0.8 ? "reminder" : null,
        sessionValues: Array.from({ length: rnd(0, 3) }, () => rnd(1, 15)),
      })),
      summary: {
        totalUses: rnd(0, 50),
        totalAdherencePercentage: rnd(0, 100),
        activePeriodsCount: rnd(0, 7),
        target: rnd(1, 5),
        aggregationType: "daily",
        currentPeriodValue: rnd(0, 5),
      },
    },
    {
      name: "BiWaze® Clear",
      unit: "mins",
      type: "clear",
      value: rnd(0, 120),
      hadConnectedDevice: Math.random() > 0.5,
      hasPairedDevice: Math.random() > 0.5,
      days: dates.map((date) => ({
        date,
        active: Math.random() > 0.5,
        completionPercentage: rnd(0, 100),
        minutes: rnd(0, 60),
        sessions: rnd(0, 4),
        sessionValues: Array.from({ length: rnd(0, 4) }, () => rnd(1, 30)),
        error: Math.random() > 0.9,
        notification: Math.random() > 0.85 ? "followup" : null,
      })),
      summary: {
        totalMinutes: rnd(0, 500),
        totalAdherencePercentage: rnd(0, 100),
        activePeriodsCount: rnd(0, 7),
        target: rnd(1, 8),
        aggregationType: "daily",
        currentPeriodValue: rnd(0, 8),
      },
    },
  ];

  // Random devices (0..2) with simple mock shape
  const devices = Array.from({ length: rnd(0, 2) }, (_, i) => ({
    id: `device-${i + 1}`,
    name: ["BiWaze-Cough", "BiWaze-Clear", "SmartBand"][rnd(0, 2)],
    connected: Math.random() > 0.5,
  }));

  // Compute oldest known therapy date if any therapy > 0 exists
  const firstTherapyDate = therapies.find(
    (t) =>
      t.breathing_treatment > 0 ||
      t.vest_treatment > 0 ||
      t.biwaze_cough > 0 ||
      t.biwaze_clear > 0
  )?.date;

  return {
    aggregationType: "Week",
    date: startDate,
    startDate,
    endDate,
    devices,
    requestedVitals: ["spo2", "heart_rate", "aqi"],
    availableVitals: [
      "spo2",
      "heart_rate",
      "aqi",
      "blood_pressure",
      "respiratory_rate",
    ],
    therapies,
    therapyData,
    vitals,
    insights: calculateInsights(vitals),
    isYearlyData: false,
    oldestKnownTherapyDate: {
      cough: firstTherapyDate ?? startDate,
      clear: firstTherapyDate ?? startDate,
    },
  };
};
